import React from "react";
import { CheckOutlined, ExclamationOutlined } from "@ant-design/icons";
import styles from "./OrderSteps.module.css";

export interface OrderStepItem {
  title: string;
  status?: "wait" | "process" | "finish" | "warn";
  icon?: React.ReactNode;
}

interface OrderStepsProps {
  steps: OrderStepItem[];
  current: number; // 0-based index
  onChange?: (index: number) => void;
}

export const OrderSteps: React.FC<OrderStepsProps> = ({ steps, current, onChange }) => {
  // 当步骤数量为 2 或 3 时，使用 flex-start 对齐
  const containerClass = steps.length <= 2 ? `${styles.container} ${styles["container-few"]}` : styles.container;

  return (
    <div className={containerClass}>
      {steps.map((step, index) => {
        const isLast = index === steps.length - 1;

        // Determine status: explicit > derived
        let status = step.status;
        if (!status) {
          if (index < current) status = "finish";
          else if (index === current) status = "process";
          else status = "wait";
        }

        const isClickable = onChange && status !== "wait"; // Allow clicking previous or current steps? Usually allow all if reachable.
        // Actually, allow clicking any step if onChange is provided, logic handled by parent.

        return (
          <React.Fragment key={index}>
            <div className={styles["step-item"]} data-status={status} onClick={() => onChange && onChange(index)}>
              <div className={styles["step-content"]}>
                <div className={styles["step-icon-wrapper"]}>{status === "finish" ? <CheckOutlined /> : status === "warn" ? <ExclamationOutlined /> : index + 1}</div>
                <div className={styles["step-title"]}>{step.title}</div>
              </div>
            </div>
            {!isLast && <div className={`${styles["separator-line"]} ${index < current ? styles["active"] : ""}`} />}
          </React.Fragment>
        );
      })}
    </div>
  );
};
